import { inject } from "@angular/core";
import { ResolveFn } from "@angular/router";
import { Observable, catchError, of, take } from "rxjs";
import { environment } from "src/environments/environment";
import { ConsentService } from "../services/consent.service";
import { CustomerSuppliedDataLoaderService } from "../services/customer-supplied-data/customer-supplied-data-loader.service";
import { CustomerService } from "../services/customer.service";
import { Monitoring } from "../utils/monitoring";

export const consentResolver: ResolveFn<Observable<any>> = () => {
  if (!environment.production && environment.skipConsents) {
    return of(true);
  }

  const consentService = inject(ConsentService);

  return consentService.fetchConsents().pipe(
    take(1),

    catchError((error) => {
      Monitoring.warn("A consent error occurred: ", {
        extras: {
          error,
        },
      });
      return of(false);
    }),
  );
};

export const customerSuppliedClientDataResolver: ResolveFn<
  Observable<CustomerSuppliedData.ClientDataWrapper | undefined>
> = () => {
  return inject(CustomerSuppliedDataLoaderService).loadClientData();
};

export const customerSuppliedDataResolver: ResolveFn<Observable<CustomerSuppliedData.Profile | undefined>> = () => {
  return inject(CustomerSuppliedDataLoaderService).loadProfile();
};

export const customerResolver: ResolveFn<Observable<CustomerMaster.Response.Customer | undefined>> = () => {
  return inject(CustomerService).fetchAndSetCustomerWithLoader();
};
